<script>
  import {onDestroy} from "svelte"
  import {useQuery} from "@sveltestack/svelte-query"
  import { getNotificationsContext } from "svelte-notifications"
  import StepBase from "./StepBase.svelte";
  import { getAutoMpsProjectContext } from "../../AutoMpsProjectContext.js";
  import {navigateI18n} from "../../../i18n/navigate.js";


  export let executionId

  const ctx = getAutoMpsProjectContext()
  const {addNotification} = getNotificationsContext()

  const query = useQuery(
    `/api/auto-mps/projects/${$ctx.projectId}/executions/${executionId}`,
    {
      refetchInterval: 1000,
    }
  )

  const unsubscribe = query.subscribe(query => {
    if (query.data && query.data.status === "executed") {
      addNotification({
        position: "top-right",
        type: "success",
        removeAfter: 4000,
        text: "成功しました。"
      })
      navigateI18n(`/auto-mps/projects/${$ctx.projectId}/executions/${executionId}`)

      unsubscribe()
    }
    if (query.data && query.data.status === "failed") {
      addNotification({
        position: "top-right",
        type: "error",
        removeAfter: 4000,
        text: "実行に失敗しました。"
      })
      navigateI18n(`/auto-mps/projects/${$ctx.projectId}`)
    }
  })

  onDestroy(() => unsubscribe())
</script>

<StepBase>
  <div style="width: 100%; height: 100%; display: grid; place-items: center">
    <div>
      Asprova AutoMPS を使用して負荷の平準化を行っています...
    </div>
  </div>
</StepBase>
